import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

export default function Edit({ attributes, setAttributes, context }) {
  return (
    <>
      <Inspector
        attributes={attributes}
        setAttributes={setAttributes}
        context={context}
      />

      {!attributes.parentTabId && (
        <div className="Container">
          <div>
            <h2>
              Por favor, insira o ID da guia que estará atrelada a esse conteúdo
              através do inspetor
            </h2>
            <p>Basta clicar aqui em cima e inserir o ID desejado</p>
          </div>
        </div>
      )}

      <section
        className="Tab-content"
        id={attributes.parentTabId}
        data-plans-id={attributes.plansId}
      >
        <div className="Container">
          <span>
            Guia pai: {attributes.parentTabId} (Isso não irá aparecer para o
            usuário e serve apenas para facilitar sua navegação)
          </span>
        </div>

        <InnerBlocks
          template={[['core/paragraph']]}
          renderAppender={InnerBlocks.DefaultBlockAppender}
        />
      </section>
    </>
  );
}
